import { Field } from 'formik';
import React, { Fragment } from 'react';

import { ModuleComponents } from '../../components/ModuleComponents';
import { Wrapped } from '../../hocs/withRenderSettings';
import {
    StoryblokFlexibleComponentButton,
    StoryblokFlexibleComponentMarkdown,
    StoryblokFormField,
} from '../../storyblok';

import { InputFile } from './Input/InputFile';
import { InputNumberLocale } from './Input/InputNumberLocale';
import { InputText } from './Input/InputText';
import { InputTextarea } from './Input/InputTextarea';

export type FormFieldsItemType =
    | StoryblokFormField
    | StoryblokFlexibleComponentMarkdown
    | StoryblokFlexibleComponentButton
    | {
          component: 'TempSelectDocument';
          _uid: string;
          selectDocumentButtonLabel: string;
          previewDocumentButtonLabel: string;
          viewDocumentsLabel: string;
          selectedDocumentText: string;
      };

interface FormFieldsItemProps {
    item: FormFieldsItemType;
}

export const FormFieldsItem = ({ item }: FormFieldsItemProps) => {
    const CustomFields = {
        file: InputFile,
        textarea: InputTextarea,
        localizedNumber: InputNumberLocale,
    } as Record<StoryblokFormField['type'], any>;

    if (item.component === 'FormField') {
        return (
            <Fragment>
                {item.label && item.type !== 'file' && (
                    <label htmlFor={item.name}>{item.label}</label>
                )}
                <Wrapped
                    renderAs={Field}
                    as={item.as}
                    name={item.name}
                    type={item.type}
                    component={
                        item.type in CustomFields
                            ? CustomFields[item.type]
                            : InputText
                    }
                    renderSettings={item.renderSettings}
                    label={item.label}
                />
            </Fragment>
        );
    }

    if (item.component === 'Button' || item.component === 'Markdown') {
        return <ModuleComponents components={[item]} />;
    }

    return null;
};
